<template>
  <div>
    <div class="col-lg-12 m-t-sm feed-activity-list">
      <div class="feed-element" v-for="note in notes" :key="note.id">
        <div class="media-body">
          <div>
            <span style="font-size: medium;">
              Note added by {{ note.author.username }}
              at <strong>{{ note.time | aTime('DD.MM.YY HH:mm')}}</strong>
            </span>
            <span class="pull-right" v-if="user.admin">
              <button class="btn btn-xs btn-danger" @click="deleteNote(note.id)">Delete</button>
            </span>
          </div>
          <div class="well">{{ note.message }}</div>
          <div class="m-t-xs">
            <file-interface :type="'messages'" :data="note" v-on:reloadData="$emit('getTaskNotes')"></file-interface>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { eventBus } from '../../../main'
import FileInterface from '../Files/FileInterface.vue'

export default {
  props: ['notes'],
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  components: {
    fileInterface: FileInterface
  },
  methods: {
    async deleteNote (id) {
      try {
        if (confirm('Are you sure yo want to delete this note?')) {
          await axios.delete(`/v2/messages/${id}`)
          eventBus.$emit('loadNotes')
          this.$toastr.success('Note deleted!', 'Success')
        }
      } catch (error) {
        this.$toastr.error('Failed to delete note', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Tabs/NotesLogs.vue